export const ItemTypes = {
  CARD: 'card',
  // CARD: 'IColumn'
}
